module.exports = __webpack_public_path__ + "images/50393f18c587f7c8f4816b53aeec9da6-welcome.jpg";